import Location from './location';
import { PATH_ACCOUNT_LOGOFF, PATH_LOGIN_LOGOUT } from '@defi/core-constants';
var Logout = {
  logout: function logout() {
    // include the loanApplicationID param to indicate which that needs to be unlocked before logging them out
    if (Location.pathname().indexOf("logout") > -1) Location.redirect(PATH_ACCOUNT_LOGOFF);else {
      Location.redirectWithReturnUrl(PATH_ACCOUNT_LOGOFF);
    }
  },
  logoutForced: function logoutForced() {
    Location.redirect("".concat(PATH_ACCOUNT_LOGOFF, "?forced=true"));
  },
  logoutDirectlyToNewLogout: function logoutDirectlyToNewLogout() {
    Location.redirect(PATH_LOGIN_LOGOUT);
  }
};
export default Logout;